<template>
  <section class="section-hero sectionBackGround">
    <div class="container shape-container d-flex align-items-center">
      <div class="row justify-content-center" style="margin-top: 20px">
        <div class="col-lg-12">
          <div class="row row-grid">
            
            <!-- 博客详情内容 -->
            <div class="col-lg-9 cl-left" style="background-color: white; padding: 20px; border-radius: 8px;">
              <div class="cl-artical-content">
                <h2 class="cl-artical-title">{{ post.title }}</h2>
                <div class="cl-card-tag">
                  <div>
                    <a :href="'/blog/category/' + post.category_id + '.html'" class="text-muted">{{ post.category }}</a>
                    / <span>{{ post.view_count }}</span> 人浏览
                    / <span>{{ post.comment_count }}</span> 人评论
                  </div>
                </div>
                <div class="cl-artical">
                  <p v-html="post.content"></p>
                </div>

                <!-- 分享及其他功能按钮 -->
                <div class="floatbar">
                  <a href="/blog/"><i class="fa fa-home"></i></a>
                  <a href="#comments"><i class="fa fa-comment"></i></a>
                  <a href="javascript:" class="gotop"><i class="fa fa-arrow-up"></i></a>
                </div>
              </div>
            </div>

            <!-- 侧边栏，显示最新文章 -->
            <div class="col-lg-3 cl-right">
              <div class="right-card">
                <div class="right-card-main">
                  <div class="right-card-title">最新文章</div>
           <ul class="right-recommended-list">
             <li v-for="article in latestArticles" :key="article.id">
               <a @click.prevent="navigateToBlogDetail(article.id)">
                 <i class="fa fa-angle-right" aria-hidden="true"></i> {{ article.title }}
               </a>
             </li>
           </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
export default {
  name: 'BlogDetail',
  data() {
    return {
      post: {}, // 博客详情
      latestArticles: [], // 最新文章列表
      isTokenVerified: false, // 避免重复验证 token
      token: '', // 保存 token
    };
  },
  methods: {
    // 获取 Cookie 中的 token
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
	 navigateToBlogDetail(articleId) {
	    this.$router.push({ name: 'BlogDetail', params: { id: articleId } });
	  },

    // 验证 token
    async verifyToken() {
      if (this.isTokenVerified) return;  // 避免重复验证
      this.token = this.getCookie('token');  // 获取 token
      if (!this.token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('token', this.token);

        const response = await axios.post('https://anthromindxx.com/ca.php?action=verifyToken', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });

        if (response.data.success) {
          this.isTokenVerified = true;
        } else {
          console.error(response.data.message);
          this.$router.push('/login');
        }
      } catch (error) {
       // console.error('Token verification failed:', error);
        this.$router.push('/login');
      }
    },

    // 获取博客详情
    async fetchBlogDetail() {
      if (!this.isTokenVerified) return;  // 如果没有通过token验证，阻止请求发送
      const postId = this.$route.params.id;  // 从路由获取文章ID

      try {
        const params = new URLSearchParams();
        params.append('id', postId);
        params.append('token', this.token);  // 传递保存的token

        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_blog_post_detail', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });

         if (response.data.success) {
          this.post = response.data.post;
        } else {
          console.error('Failed to load blog post:', response.data.error);
        }
      } catch (error) {
        console.error('Error fetching blog post:', error);
      }
    },

    // 获取最新文章
    async fetchLatestArticles() {
      if (!this.isTokenVerified) return;  // 如果没有通过token验证，阻止请求发送

      try {
        const params = new URLSearchParams();
        params.append('token', this.token);  // 传递保存的token

        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_latest_blog_posts', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });

         if (response.data.success) {
          this.latestArticles = response.data.posts;
        } else {
          console.error('Failed to load latest articles:', response.data.error);
        }
      } catch (error) {
        console.error('Error fetching latest articles:', error);
      }
    }
  },

  // 使用 async/await 确保流程顺序
  async created() {
    const token = this.getCookie('token');
    if (token) {
      await this.verifyToken();
      if (this.isTokenVerified) {  // 通过验证后获取博客数据
        this.fetchBlogDetail();  // 调用获取博客详情
        this.fetchLatestArticles();  // 调用获取最新文章
      }
    } else {
      this.$router.push('/login');
    }
  },
  watch: {
    '$route.params.id'(newId) {
      // 当路由参数中的 id 发生变化时，重新获取文章详情
      this.fetchBlogDetail();
    }
  }
  
};
</script>

<style scoped>
.sectionBackGround {
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
  overflow: auto;
}

.cl-left {
  padding: 20px;
}
.cl-artical-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.cl-card-tag {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}
.cl-artical p {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
}
.floatbar a {
  color: #666;
  margin-right: 15px;
  font-size: 18px;
}
.right-card-main {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.right-card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.right-recommended-list li {
  list-style: none;
  margin-bottom: 10px;
}
.right-recommended-list li a {
  text-decoration: none;
  color: #007bff;
}
.right-recommended-list li a i {
  margin-right: 5px;
}
</style>